import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import {
  Input,
  Button,
} from '@pearsontechnology/aero-components';
import { commandWorkspaceProjectCreate } from 'containers/ConnectionManager/actions';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, { ModalContent, ModalActions } from 'components/Modal';
import workspaceService from 'services/WorkspaceService';
import messages from './messages';

const validateFields = (values) => {
  const errors = {};

  if (!values.projectName) {
    errors.projectName = intl.formatMessage(messages.projectNameValidationIsRequired);
  }

  return errors;
};

const CreateProjectModal = ({ visible, onDismiss, createProject }) => {
  const handleCreateProject = (values) => {
    const workspaceId = workspaceService.getSelectedWorkspaceId();

    createProject({ name: values.projectName }, workspaceId);
  };

  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
      icon="duotoneProjects"
      title={intl.formatMessage(messages.newProject)}
    >
      <Formik
        onSubmit={handleCreateProject}
        validate={validateFields}
        initialValues={{ projectName: '' }}
      >
        <Form>
          <ModalContent>
            <Field name="projectName">
              {({ field, form }) => (
                <Input
                  name={field.name}
                  value={field.value}
                  onChange={field.onChange}
                  label={intl.formatMessage(messages.projectName)}
                  placeholder={intl.formatMessage(messages.projectNamePlaceholder)}
                  feedback={form.errors[field.name]}
                />
              )}
            </Field>
          </ModalContent>
          <ModalActions>
            <Button primary type="submit">{intl.formatMessage(messages.createProject)}</Button>
          </ModalActions>
        </Form>
      </Formik>
    </Modal>
  );
};

CreateProjectModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  createProject: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  createProject: (project, workspaceId) =>
    dispatch(commandWorkspaceProjectCreate(project, workspaceId)),
});

export default connect(null, mapDispatchToProps)(CreateProjectModal);
